import { render, staticRenderFns } from "./nine-year.vue?vue&type=template&id=5cc902db&scoped=true&"
import script from "./nine-year.vue?vue&type=script&lang=js&"
export * from "./nine-year.vue?vue&type=script&lang=js&"
import style0 from "./nine-year.vue?vue&type=style&index=0&id=5cc902db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc902db",
  null
  
)

export default component.exports